import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import CrewContainer from '../../layouts-components__common-cases/crew-container';

import './style.sass';
import CommonTitle from '../../../common-components/common-title';

const team = {
    crewTitle: 'Вебпрактик',
    crewSubtitle: null,
    crewList: [
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: 'Ксения Жукова',
            crewItemSubtitle: 'Старший менеджер проектов',
        },
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: '+Менеджер проектов',
            crewItemSubtitle: '',
            color: true,
        },
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: '+2 специалиста PPC',
            crewItemSubtitle: '',
            color: true,
        },
    ],
};

const Team = () => {
    return (
        <div className="team">
            <FullWrapper>
                <div className="team__facebook">
                    * Соцсеть Facebook запрещена в РФ. 21.03.2022 компания Meta признана в России
                    экстремистской организацией.
                </div>
                <CommonTitle>Команда</CommonTitle>
                <CrewContainer container={team} />
            </FullWrapper>
        </div>
    );
};

export default Team;
